export default __webpack_public_path__ + "static/media/email.67bda941.png";